import { modulePage } from "../../core/Application";
import { BannerApi, BannerItem, BannerItemsResponse, BannerSize } from "../api/BannerApi";

export class Banner implements modulePage {
    readonly name: string = "Banner";

    private bannerApi: BannerApi;
    private banners: BannerItemsResponse;

    constructor() {
        this.bannerApi = new BannerApi();
    }

    getBanners = async () => {
        const bannersContainers = document.getElementsByClassName('banner') as HTMLCollectionOf<HTMLElement>;
        const bannerTop = Array.from(bannersContainers).filter(element => {
            return element.dataset.size === BannerSize.TOP;
        });
        const bannerContent = Array.from(bannersContainers).filter(element => {
            return element.dataset.size === BannerSize.CONTENT;
        });
        const bannerSidebar = Array.from(bannersContainers).filter(element => {
            return element.dataset.size === BannerSize.SIDEBAR;
        });

        this.banners = await this.bannerApi.getBanners(this.arrayToQueryString([
            {
                position: BannerSize.TOP,
                qty: bannerTop.length
            },
            {
                position: BannerSize.CONTENT,
                qty: bannerContent.length
            },
            {
                position: BannerSize.SIDEBAR,
                qty: bannerSidebar.length
            }
        ]));

        this.renderBanner(bannerTop);
        this.renderBanner(bannerContent);
        this.renderBanner(bannerSidebar);
    }

    private renderBanner(elements: HTMLElement[]) {
        Array.from(elements).forEach((element, i) => {
            const banner = this.banners[element.dataset.size][i];
            element.classList.add('mb-3');
            element.innerHTML = this.getBannerTemplate(banner);
        });
    }

    private getBannerTemplate(banner: BannerItem): string {
        return `<a href="/banners/click/${banner.id}"  title="${banner.description}" target="_blank" ref="noindex,nofollow">
        <img src="${banner.public_image}" alt="${banner.name}" style="width:100%"/>
        </a>`;
    }

    private arrayToQueryString(array: { position: BannerSize; qty: number }[]): string {
        return array.map((item, index) => {
          const positionKey = `banners[${index}][position]`;
          const qtyKey = `banners[${index}][qty]`;
      
          const positionValue = encodeURIComponent(item.position);
          const qtyValue = encodeURIComponent(String(item.qty));
      
          return `${positionKey}=${positionValue}&${qtyKey}=${qtyValue}`;
        }).join('&');
      }

    init(): void {
        this.getBanners();
    }

}